<template>
  <b-col>
    <b-row>
      <b-col :ref="'input__' + priceTitle" cols="12" sm="6" md="5" lg="4">
        <label :for="'input__' + priceTitle"> Price </label>
        <b-form-input
          :id="'input__' + priceTitle"
          v-model.number="$v.form.normalPrice.$model"
          type="number"
          :disabled="disabled"
          :state="$v.form.normalPrice.$anyError ? false : null"
          min="0"
          :aria-describedby="'input__' + priceTitle + '-invalid-feedback'"
          class="mt-2"
          :class="'input__' + priceTitle"
          placeholder="e.g, 1,000 Thai Baht"
          @keydown="onKeydown($event, $v.form.normalPrice.$model)"
        />

        <b-form-invalid-feedback
          v-if="!$v.form.normalPrice.required || !$v.form.normalPrice.minValueValue"
          :id="'input__' + priceTitle + '-invalid-feedback'"
          class="mt-2"
        >
          {{ priceTitle === 'verify-learn-price' ? `Learn + Verify` : `Verify` }}
          price must be greater than or equal to 0.
        </b-form-invalid-feedback>
      </b-col>

      <!-- price discount -->
      <b-col :ref="'input__' + priceTitle + '-discount'" cols="12" sm="6" md="5" lg="4">
        <label :for="'input__' + priceTitle + '-discount'">
          Discount price
          <span class="text-black-50">(Optional)</span>
        </label>
        <b-form-input
          :id="'input__' + priceTitle + '-discount'"
          v-model.number="$v.form.discountPrice.$model"
          type="number"
          :disabled="disabled || form.normalPrice === 0"
          :state="$v.form.discountPrice.$anyError ? false : null"
          min="0"
          :aria-describedby="'input__' + priceTitle + '-discount-invalid-feedback'"
          class="mt-2"
          :class="'input__' + priceTitle + '-discount'"
          placeholder="e.g, 500 Thai Baht"
          @keydown="onKeydown($event, $v.form.discountPrice.$model)"
        />

        <b-form-invalid-feedback
          v-if="!$v.form.discountPrice.between || !$v.form.discountPrice.sameAs"
          :id="'input__' + priceTitle + '-discount-invalid-feedback'"
          class="mt-2"
        >
          Discount price must be lower than the normal price.
        </b-form-invalid-feedback>

        <b-form-invalid-feedback
          v-if="!$v.form.discountPrice.minValueValue"
          :id="'input__' + priceTitle + '-discount-invalid-feedback'"
          class="mt-2"
        >
          {{ priceTitle === 'verify-learn-price' ? `Learn + Verify` : `Verify` }}
          price must be greater than 0.
        </b-form-invalid-feedback>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import { requiredIf, minValue, between, not, sameAs } from 'vuelidate/lib/validators';

export default {
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        normalPrice: null,
        discountPrice: null
      })
    },

    disabled: {
      type: Boolean,
      default: false
    },
    priceTitle: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      form: {
        normalPrice: this.modelValue.normalPrice,
        discountPrice: this.modelValue.discountPrice
      }
    };
  },

  watch: {
    form: {
      deep: true,
      handler(value) {
        if (this.form.normalPrice === 0) {
          this.$set(this.form, 'discountPrice', null);
        }
        this.$emit('change', value);
      }
    },
    modelValue: {
      deep: true,
      immediate: true,
      handler(modelValue) {
        this.updateForm(modelValue);
      }
    }
  },

  validations() {
    return {
      form: {
        normalPrice: {
          required: requiredIf((value) => {
            return !this.disabled || value.discountPrice;
          }),
          minValueValue: minValue(0)
        },
        discountPrice: {
          sameAs: not(
            sameAs(function () {
              return this.form.normalPrice;
            })
          ),
          between: between(this.form.discountPrice, this.form.normalPrice),
          minValueValue: minValue(0)
        }
      }
    };
  },

  methods: {
    onKeydown(event, modelValue) {
      if (event.key === '.' || event.key === '-' || (event.key === '0' && modelValue === 0)) {
        event.preventDefault();
      }
    },
    updateForm(modelValue) {
      if (this.form.normalPrice === null && modelValue.normalPrice !== null) {
        this.$set(this.form, 'normalPrice', modelValue.normalPrice);
      }
      if (this.form.discountPrice === null && modelValue.discountPrice !== null) {
        this.$set(this.form, 'discountPrice', modelValue.discountPrice);
      }
    }
  }
};
</script>
